// extracted by mini-css-extract-plugin
module.exports = {"stepper":"CreateProperty_stepper__rq_JD","footer":"CreateProperty_footer__1fb3f","message":"CreateProperty_message__1TkaX"};